import React from 'react';
import S from './ErrorArea.styles';
const ErrorArea = (props) => {
    return (React.createElement(S.ErrorArea, null,
        ((props.errorSummary && props.errorSummary?.length > 1) ||
            (props.validationErrors && props.validationErrors?.length > 0)) &&
            props.message && React.createElement(S.ErrorTitle, null, props.message),
        props.errorSummary && props.errorSummary?.length > 1 && (React.createElement(S.ErrorSummary, null, props.errorSummary)),
        props.validationErrors && props.validationErrors.length > 0 && (React.createElement(S.ErrorList, null, props.validationErrors.map((x, i) => (React.createElement(S.ErrorListItem, { key: i, dangerouslySetInnerHTML: { __html: x } })))))));
};
export default ErrorArea;
